/**
 * Collection banner Read more (PC + Mobile same logic).
 * Collapsed preview is SSR'd — no expand→collapse CLS on either viewport.
 * Mobile ~155 chars / Desktop ~305 chars; JS only refines word boundaries + toggle.
 */
(function () {
  var MOBILE_MAX = 155;
  var DESKTOP_MAX = 305;
  var MQ = '(min-width: 750px)';

  function getMaxLen() {
    return window.matchMedia(MQ).matches ? DESKTOP_MAX : MOBILE_MAX;
  }

  function isSpace(ch) {
    return (
      ch === ' ' ||
      ch === '\n' ||
      ch === '\r' ||
      ch === '\t' ||
      ch === '\u00a0' ||
      ch === '\u3000'
    );
  }

  function truncateAtWord(text, maxLen) {
    if (!text || text.length <= maxLen) {
      return { excerpt: text || '', truncated: false };
    }

    var slice = text.slice(0, maxLen);
    var boundary = Math.max(
      slice.lastIndexOf(' '),
      slice.lastIndexOf('\n'),
      slice.lastIndexOf('\r'),
      slice.lastIndexOf('\t'),
      slice.lastIndexOf('\u00a0'),
      slice.lastIndexOf('\u3000')
    );

    var end;
    if (boundary > 0) {
      end = boundary;
    } else {
      var nextSpace = -1;
      for (var k = maxLen; k < text.length; k++) {
        if (isSpace(text[k])) {
          nextSpace = k;
          break;
        }
      }
      end = nextSpace !== -1 ? nextSpace : maxLen;
    }

    var excerpt = text.slice(0, end).replace(/[\s\u00a0\u3000]+$/g, '');
    if (!excerpt.length) excerpt = text.slice(0, maxLen).trim();
    if (excerpt.length >= text.length) return { excerpt: text, truncated: false };
    return { excerpt: excerpt, truncated: true };
  }

  function setPreviewText(previewEl, mobileText, desktopText) {
    var m = previewEl.querySelector('[data-desc-preview-m]');
    var d = previewEl.querySelector('[data-desc-preview-d]');
    if (m || d) {
      if (m) m.textContent = mobileText;
      if (d) d.textContent = desktopText;
      return;
    }
    previewEl.textContent = window.matchMedia(MQ).matches ? desktopText : mobileText;
  }

  function initWrap(wrap) {
    var body = wrap.querySelector('[data-collection-description-body]');
    var fullEl = body && body.querySelector('[data-desc-full]');
    var previewEl = body && body.querySelector('[data-desc-preview]');
    var btn = wrap.querySelector('[data-readmore-toggle]');
    var labelMore = wrap.querySelector('[data-readmore-label]');
    var labelLess = wrap.querySelector('[data-readmore-label-less]');

    if (!body || !fullEl || !previewEl || !btn) return;

    function applyStatic() {
      wrap.removeAttribute('data-readmore-truncates');
      wrap.classList.add('collection-hero__description-wrap--static');
      btn.hidden = true;
      fullEl.removeAttribute('hidden');
      if (labelMore) labelMore.hidden = false;
      if (labelLess) labelLess.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }

    function syncCollapsedView() {
      if (wrap.classList.contains('is-expanded')) return;

      var plain = (fullEl.textContent || '').replace(/\r/g, '').trim();
      var mobile = truncateAtWord(plain, MOBILE_MAX);
      var desktop = truncateAtWord(plain, DESKTOP_MAX);
      var active = window.matchMedia(MQ).matches ? desktop : mobile;

      wrap.classList.remove('collection-hero__description-wrap--static');

      if (!mobile.truncated && !desktop.truncated) {
        applyStatic();
        return;
      }

      /* Same logic both ends: keep truncates + dual previews; hide button only if
         current viewport does not need truncation. */
      wrap.setAttribute('data-readmore-truncates', 'true');
      setPreviewText(
        previewEl,
        mobile.truncated ? mobile.excerpt + '...' : plain,
        desktop.truncated ? desktop.excerpt + '...' : plain
      );

      if (!active.truncated) {
        btn.hidden = true;
        fullEl.removeAttribute('hidden');
        wrap.classList.add('collection-hero__description-wrap--static');
        wrap.removeAttribute('data-readmore-truncates');
        return;
      }

      btn.hidden = false;
      fullEl.setAttribute('hidden', '');
      if (labelMore) labelMore.hidden = false;
      if (labelLess) labelLess.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var expanded = wrap.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (labelMore) labelMore.hidden = expanded;
      if (labelLess) labelLess.hidden = !expanded;

      if (expanded) {
        fullEl.removeAttribute('hidden');
      } else {
        fullEl.setAttribute('hidden', '');
        syncCollapsedView();
      }
    });

    syncCollapsedView();
    window.addEventListener('load', syncCollapsedView);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (wrap.classList.contains('is-expanded')) return;
        syncCollapsedView();
      }, 150);
    });
  }

  document.querySelectorAll('[data-collection-description-readmore]').forEach(initWrap);
})();
